import { styled } from "@mui/material"

export const Wrapper = styled("div")(() => ({
    width: "100px",
}))
